<template>
  <div class="content-wrapper view-tier-report p-0">
    <div class="content">
      <b-card>
        <h4 class="mb-0"><i class="fas fa-chart-pie"></i> รายงานระดับลูกค้า</h4>
        <b-card no-body class="mt-1 mb-0 pb-0">
          <b-tabs class="mb-0" v-model="tabIndex" card>
            <b-tab lazy title="ภาพรวมจำนวนคนไข้" @click="saveTabIndex">
              <TierDistributionReport />
            </b-tab>
            <b-tab lazy title="รายชื่อคนไข้ตามระดับ" @click="saveTabIndex">
              <TierRosterReport />
            </b-tab>
            <b-tab lazy title="ประวัติการเปลี่ยนระดับ" @click="saveTabIndex">
              <TierUpLogReport />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-card>
      <PdfExport ref="pdfExport" />
    </div>
  </div>
</template>

<script>
import PdfExport from "@/components/PdfExport";

import TierDistributionReport from "@/components/reports/TierDistributionReport";
import TierRosterReport from "@/components/reports/TierRosterReport";
import TierUpLogReport from "@/components/reports/TierUpLogReport";
import { eventBus } from "../main";

const TAB_STORAGE_KEY = "tierReportTabIndex";

export default {
  name: "TierReport",
  components: {
    PdfExport,
    TierDistributionReport,
    TierRosterReport,
    TierUpLogReport,
  },
  data() {
    return {
      tabIndex: null,
    };
  },
  methods: {
    // Same "remember which report tab I was on" pattern as
    // ClinicIncomeReport.vue — persisted per-screen (own storage key) so it
    // does not collide with that screen's own tabIndex.
    saveTabIndex() {
      this.$nextTick(() => {
        localStorage.setItem(TAB_STORAGE_KEY, this.tabIndex);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tabIndex = parseInt(localStorage.getItem(TAB_STORAGE_KEY));
    });
    // exportReportToPdf (src/utils/reportExport.js) only ever emits this
    // event — nothing renders a PDF unless the mounting view both mounts
    // <PdfExport ref="pdfExport"> and registers this listener, same pattern
    // as BranchIncomeReport.vue. Without it, ส่งออก → PDF on any of this
    // screen's three tier reports silently does nothing.
    this.handleExportReportPdf = payload => {
      if (this.$refs.pdfExport) this.$refs.pdfExport.generatePdf(payload);
    };
    eventBus.$on("exportReportPdf", this.handleExportReportPdf);
  },
  beforeDestroy() {
    if (this.handleExportReportPdf) {
      eventBus.$off("exportReportPdf", this.handleExportReportPdf);
    }
  },
};
</script>

<style scoped></style>
